const idsToIndexes = (ids: string[], objects: { id: string }[]): number[] => {
  const indexMap: { [id: string]: number } = objects.reduce(
    (acc, obj, index) => ({ ...acc, [obj.id]: index }),
    {},
  );

  return ids.map((id) => indexMap[id] ?? -1);
};

export default idsToIndexes;
